module.exports = __webpack_public_path__ + "static/img/poll@2x.db0b401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poll@2x.png
// module id = Ahw0
// module chunks = 1